module.exports = __webpack_public_path__ + "group_buy/groupbuy_step3-b3355633203bbc6459f9dfb1e2c99422.png";